export const PROGRAM_CATEGORIES = [
  { id: "loan_lifecycle", label: "Loan lifecycle" },
  { id: "collections", label: "Collections & reminders" },
  { id: "engagement", label: "Engagement & celebrations" },
  { id: "service", label: "Customer service" },
  { id: "marketing", label: "Marketing & outreach" },
];

export const TEMPLATE_KEYS = [
  { value: "loan_approved", label: "Loan approved", category: "loan_lifecycle", variables: ["amount"] },
  {
    value: "disbursement_notice",
    label: "Disbursement notice",
    category: "loan_lifecycle",
    variables: ["amount", "reference"],
  },
  {
    value: "payment_received",
    label: "Payment received",
    category: "loan_lifecycle",
    variables: ["amount"],
  },
  {
    value: "loan_maturity_reminder",
    label: "Loan maturity reminder",
    category: "loan_lifecycle",
    variables: ["amount", "due_date", "reference"],
  },
  {
    value: "repayment_due_reminder",
    label: "Repayment due reminder",
    category: "collections",
    variables: ["amount", "due_date"],
    collection: true,
  },
  {
    value: "overdue_reminder",
    label: "Overdue reminder",
    category: "collections",
    variables: ["amount"],
    collection: true,
  },
  {
    value: "ptp_reminder",
    label: "Promise-to-pay reminder",
    category: "collections",
    variables: ["amount", "due_date"],
    collection: true,
  },
  {
    value: "birthday_wish",
    label: "Birthday wish",
    category: "engagement",
    variables: ["customer_name"],
  },
  {
    value: "holiday_wish",
    label: "Holiday / festival wish",
    category: "engagement",
    variables: ["customer_name", "holiday_name"],
  },
  {
    value: "welcome_new_borrower",
    label: "Welcome new borrower",
    category: "engagement",
    variables: ["customer_name"],
  },
  {
    value: "account_anniversary",
    label: "Account anniversary",
    category: "engagement",
    variables: ["customer_name", "years"],
  },
  {
    value: "loyalty_thanks",
    label: "Loyalty thank-you",
    category: "engagement",
    variables: ["customer_name"],
  },
  {
    value: "service_followup",
    label: "Service follow-up",
    category: "service",
    variables: ["customer_name", "reference"],
  },
  {
    value: "survey_request",
    label: "Feedback survey",
    category: "service",
    variables: ["customer_name", "survey_link"],
  },
  {
    value: "marketing_promo",
    label: "Promotional offer",
    category: "marketing",
    variables: ["customer_name", "offer_details"],
  },
  {
    value: "product_cross_sell",
    label: "Product cross-sell",
    category: "marketing",
    variables: ["customer_name", "product_name"],
  },
];

export const CHANNELS = [
  { value: "sms", label: "SMS" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
];

export const DELIVERY_STATUSES = [
  { value: "", label: "All statuses" },
  { value: "pending", label: "Pending" },
  { value: "sent", label: "Sent" },
  { value: "delivered", label: "Delivered" },
  { value: "failed", label: "Failed" },
];

export function templateMeta(key) {
  return TEMPLATE_KEYS.find((t) => t.value === key);
}

export function isCollectionTemplate(key) {
  return Boolean(templateMeta(key)?.collection);
}

export function templatesByCategory(categoryId) {
  return TEMPLATE_KEYS.filter((t) => t.category === categoryId);
}

export const deliveryStatusColor = {
  pending: "secondary",
  sent: "info",
  delivered: "success",
  failed: "danger",
};

export const AUTOMATION_CATEGORY_COLORS = {
  loan_lifecycle: "primary",
  collections: "warning",
  engagement: "success",
  service: "info",
  marketing: "secondary",
};
